import { PaginatedRequest } from '../types/api';
import {
  CreateUserNoteRequest,
  CreateUserNoteResponse,
  FetchUserNoteResponse,
  FetchUserNotesResponse,
  UpdateUserNoteRequest,
  UpdateUserNoteResponse,
} from '../types/userNotes';
import { toQueryParams } from '../utils/request';
import { ApiService } from './common/ApiService';

class UserNotesService extends ApiService {
  pathname = 'admin/user-notes';

  fetchUserNotes = ({ userId, ...data }: PaginatedRequest & { userId: number }) =>
    this.get<FetchUserNotesResponse>(`${this.pathname}/user/${userId}?${toQueryParams(data)}`);

  fetchUserNote = ({ noteId, ...data }: PaginatedRequest & { noteId: number }) =>
    this.get<FetchUserNotesResponse>(`${this.pathname}/${noteId}?${toQueryParams(data)}`);

  deleteUserNote = async (id: number) => this.delete<FetchUserNoteResponse>(`${this.pathname}/${id}`);

  setDefaultUserNote = async (id: number) =>
    this.put<FetchUserNoteResponse, object>(`${this.pathname}/${id}/default`, {});

  createUserNote = async (userNote: CreateUserNoteRequest) =>
    this.post<CreateUserNoteResponse, CreateUserNoteRequest>(`${this.pathname}`, userNote);

  updateUserNote = async ({ id, ...userNote }: UpdateUserNoteRequest) =>
    this.put<UpdateUserNoteResponse, Omit<UpdateUserNoteRequest, 'id'>>(`${this.pathname}/${id}`, userNote);
}

export const userNoteService = new UserNotesService();
